import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers } from 'recompose'

import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookModels from 'app/modules/playbook/models'
import { weakUuid } from 'app/modules/playbook/helpers'
import { isOnFreePlan } from 'app/modules/gates/selectors'

import ConditionSet from './component'

const mapStateToProps = (state, props) => ({
  conditionSet: PlaybookSelectors.getConditionSet(state, props),
  isOnFreePlan: isOnFreePlan(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      deleteConditionSet: PlaybookActions.deleteConditionSet,
      addCondition: PlaybookActions.addCondition,
      showConditionModal: PlaybookActions.showConditionModal,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onAddConditionClick: props => () => {
      const id = weakUuid()
      props.actions.addCondition({
        condition: PlaybookModels.Condition({ id }),
        conditionSetId: props.id,
      })
      props.actions.showConditionModal(id)
    },
  })
)(ConditionSet)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/ConditionSet/index.js